import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Bar } from 'react-chartjs-2'

import DataProvider from './DataProvider'
import { loadByCar } from './asyncAction'
import { formBarData } from './proxy-chartjs.js'


const BLACKLIST = ['Другая']

class CarGraph extends Component {
	render() {
		let rawData = this.props.data.toJS()[0]
		for (let key of BLACKLIST) {
			delete rawData[key]
		}
		let data = formBarData(rawData, {
			annotate: this.props.annotate,
			mainColor: "248, 151, 26",
			topTen: true,
		})

		return (
			<div className="CarGraph">
				<Bar
					data={data}
					options={this.props.chartOptions}
					height={this.props.height}
				/>
			</div>
		);
	}
}


const PATH = ['detail', 'byCar']
const SOURCES = [ loadByCar ]

class CarGraphRoot extends Component {
	render() {
		return (
			<div className="CarGraphRoot" key="CarGraphRoot">
				<DataProvider
					dataKey={`${this.props.dateFrom}...${this.props.dateTo} ${this.props.detailTopicID} ${this.props.detailSource}`}
					path={PATH}
					sources={SOURCES}
					component={CarGraph}
					{...this.props}
				/>
			</div>
		)
	}
}

const mapStateToProps = (state, ownProps) => ({
	dateFrom: state.getIn(['filterDate', 'from']),
	dateTo: state.getIn(['filterDate', 'to']),

	detailTopicID: state.getIn(['detail', 'filterTopicID']),
	detailSource: state.getIn(['detail', 'filterSource']),

	// dynamicTopicID: state.getIn(['dynamic', 'filterTopicID']),
})

const mapDispatchToProps = (dispatch, ownProps) => ({})

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(CarGraphRoot)
